import { Link as RmxLinx } from "@remix-run/react";
import { type RemixLinkProps } from "@remix-run/react/dist/components.js";
import { cn } from "~/utils/misc.tsx";
export function Link({ children, className, isDisabled, ...props }: RemixLinkProps & { isDisabled?: boolean }) {
    return (
        <RmxLinx
            className={cn("text-blue-600 hover:text-blue-800 cursor-pointer",  { "pointer-events-none" : isDisabled }, className)}
            onClick={e => { e.stopPropagation() }}
            {...props}
        >
            {children}
        </RmxLinx>
    )
}